import * as React from 'react';
import RBSelectList from '../../components/RBSelectList/RBSelectList';
import Api from '../../services/Api';
import { ApiResponse } from 'apisauce';
import { b64toBlob } from '../PrintPDF/common/utils';
import { Button, Col, Form, Row } from 'react-bootstrap';

export interface IExportButtonProps {
  reportId: string;
  getBookmarkState: () => Promise<string>;
}

export interface IExportButtonState {
  generatingFile: boolean;
  error: string;
}
const initialState: IExportButtonState = {
  generatingFile: false,
  error: '',
};

export default class ExportButton extends React.Component<
  IExportButtonProps,
  IExportButtonState
> {
  public constructor(props: IExportButtonProps) {
    super(props);
    this.state = initialState;
  }

  export = async () => {
    this.setState({ generatingFile: true, error: "" });
    const state = await this.props.getBookmarkState();
    Api.post(`PBI/ExportPowerBiReport`, {
      reportId: this.props.reportId,
      exportType: "pdf",
      bookmarkState: state,
    })
      .then((response: ApiResponse<any>) => {
        if (response.ok && response.data.id) {
          this.pollForPdfGenerated(response.data.id);
        } else {
          this.setState({ error: "Error creating file!" });
        }
      })
      .catch((ex) => {
        console.log(ex);
        this.setState({ error: "Error creating file!" });
      });
  };

  pollForPdfGenerated = (printId) => {
    Api.post(`PBI/CheckExportPowerBiReportStatus`, {
      pdfPrintId: printId,
    })
      .then((response: ApiResponse<any>) => {
        if (response.ok && response.data && response.data.file) {
          this.setState({ generatingFile: false }, () => {
            const file = b64toBlob(response.data.file, "application/pdf");
            const url = window.URL.createObjectURL(file);
            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.src = url;
            document.body.appendChild(iframe);
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          });
        } else {
          setTimeout(() => {this.pollForPdfGenerated(printId)}, 5000);
        }
      })
      .catch((ex) => {
        console.log(ex);
        this.setState({ error: "Error creating file!" });
      });
  };

  public render() {
    return (
      <React.Fragment>
        <Row>
          <Col>
            <Form.Group as={Row}>
              <Button
                onClick={async (e) => this.export()}
                className="btn btn-primary"
                disabled={this.state.generatingFile}
              >
                {!this.state.generatingFile && (
                  <React.Fragment>Print to PDF</React.Fragment>
                )}
                {this.state.generatingFile && (
                  <React.Fragment>Creating File</React.Fragment>
                )}
              </Button>
              &nbsp;&nbsp;
              {this.state.generatingFile && (
                <img
                  src={require("../../../src/assets/SmartAdmin/img/32/Marty.gif")}
                />
              )}
              {this.state.error.trim().length > 0 && (
                <span className="red">{this.state.error}</span>
              )}
            </Form.Group>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}
